import {useNavigation, useRoute} from '@react-navigation/native';
import React from 'react';
import {View, Text} from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import {useCssStyle} from '../../customHook/getCssStyle';
import {ScrollView} from 'react-native-gesture-handler';
import CustomPressable from '../../components/customPressable/customPressable';
import {formatDate} from '../../js/formatDate';
import {formatLocalTime} from '../../js/utility';
import { useTranslation } from 'react-i18next';

const GuestItineraryDetails = () => {
  const route = useRoute();
  const {item} = route.params || {};
  const navigation = useNavigation();
  const getStyles = useCssStyle();
  const {t} = useTranslation();

  const itinerary = item?.itineraries ? item?.itineraries[0] : item;
  const metaData = itinerary?.itineraryMetaData || {};

  console.log("details : ", itinerary, metaData);

  const renderItem = (label, value) => {
    return (
      <View style={getStyles(['guestItinerary_detailItem'])}>
        <Text style={getStyles(['guestItinerary_detailLabel'])}>{label}</Text>
        <Text style={getStyles(['guestItinerary_detailValue'])}>{value || "-"}</Text>
      </View>
    );
  };

  return (
    <View
      style={getStyles([
        'widgetRootContainer',
        'guestItineraryDetails_RootContainer',
      ])}>
      <HeaderWithBack handleCustomBackPress={() => navigation.goBack()} />

      <ScrollView
        automaticallyAdjustKeyboardInsets={true}
        contentContainerStyle={getStyles([
          'widgetmainContainer',
          'guestItineraryDetails_MainContainer',
        ])}
        showsVerticalScrollIndicator={false}>
        <View style={getStyles(['widgetmainContainerHeaderContainer', 'guestItineraryDetails_HeaderContainer'])}>
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'guestItineraryDetails_HeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'guestItineraryDetailsHeaderTitle'])}>
              {itinerary?.itineraryName}
            </Text>
          </View>
        </View>


        <View style={getStyles(['widgetmainContainerChildContainer', 'guestItineraryDetailsChildContainer'])}>
          <View style={getStyles(['widgetmainContainerChildContainer_timeDateContainer', 'guestItineraryDetails_timeDateContainer'])}>
            <View style={getStyles(['widgetmainContainerChildContainer_timeDateItem', 'guestItineraryDetails_timeDateItem'])}>
              <Text style={getStyles(['widgetmainContainerChildContainer_subHeading', 'guestItineraryDetails_subHeading'])}>{t('guest_itinerary_details.date')}</Text>
              <Text style={getStyles(['widgetmainContainerChildContainer_bodyText', 'guestItineraryDetails_bodyText'])}>
                {formatDate(itinerary?.itineraryDateTime)}
              </Text>
            </View>

            <View style={getStyles(['widgetmainContainerChildContainer_timeDateItem', 'guestItineraryDetails_timeDateItem'])}>
              <Text style={getStyles(['widgetmainContainerChildContainer_subHeading', 'guestItineraryDetails_subHeading'])}>{t('guest_itinerary_details.time')}</Text>
              <Text style={getStyles(['widgetmainContainerChildContainer_bodyText', 'guestItineraryDetails_bodyText'])}>
                {formatLocalTime(new Date(itinerary?.itineraryDateTime))}
              </Text>
            </View>
          </View>

          {itinerary?.itineraryDescription && (
            <View style={getStyles(['widgetmainContainerChildContainer_descriptionContainer', 'guestItineraryDetails_descriptionContainer'])}>
              <Text style={getStyles(['widgetmainContainerChildContainer_description', 'guestItineraryDetails_description'])}>
                {itinerary.itineraryDescription}
              </Text>
            </View>
          )}

          {metaData && <View style={getStyles(['widgetmainContainerChildContainer_detailsContainer', 'guestItineraryDetails_detailsContainer'])}>
            <Text
              style={getStyles([
                'widgetmainContainerChildContainer_details',
                'guestItinerary_subHeading',
                'guestItinerary_details',
              ])}>
              {t('guest_itinerary_details.details')}
            </Text>

            {renderItem('Guest Contact Info', metaData["Guest Contact Info"])}
            {/* {renderItem('Restaurant', JSON.parse(metaData.Restaurant)?.text)} */}
            {renderItem('Number in Party', metaData["Number in Party"])}
            {renderItem('Requested Time', metaData["Requested Time"])}
            {renderItem('Confirmed with', metaData["Confirmed with"])}
            
            {renderItem('Service Name', metaData["Service Name"])}

            {renderItem('Status', metaData["Status"])}
            {renderItem('Time', metaData["Time"])}
            {renderItem('Type', metaData["Type"])}

          </View>}
        </View>
      </ScrollView>
    </View>
  );
};

export default GuestItineraryDetails;
